import {MatchDistrictRelationEvent} from './MatchDistrictRelationEvent';

/**
 * Fired if the link of a match to a district is deleted.
 */
export class MatchDistrictRelationDeleted extends MatchDistrictRelationEvent {}
